import React from 'react';
import { FiPhone, FiMapPin, FiFile, FiMail } from "react-icons/fi";
import { FiFacebook, FiTwitter, FiInstagram, FiLinkedin } from "react-icons/fi";
import {Link} from "react-router-dom";

const socialmedia = [
    {
        name:"Facebook",
        icon:<FiFacebook />,
        link:"https://www.facebook.com/IEEE.SB.ISSATSO",
    },
    {
        name:"Twitter",
        icon:<FiTwitter />,
        link:"https://twitter.com/ieee_issatso_sb",
    },
    {
        name:"Instagram",
        icon:<FiInstagram />,
        link:"https://www.instagram.com/ieee.issatso.student.branch/",
    },
    {
        name:"Linkedin",
        icon:<FiLinkedin />,
        link:"https://www.linkedin.com/company/ieee-issatso/",
    },

]

const AboutFive = () => {
    return (
        <div className="about-style-5 rn-section-gapBottom">
            <div className="container">
                <div className="row">
                    <div className="col-lg-10 offset-lg-1">
                        <div className="row row--0 about-wrapper align-items-center theme-shape">
                            <div className="col-lg-6">
                                <div className="thumbnail">
                                    <img src="./images/team/dalybzr.jpg" alt="About Images" />
                                </div>
                            </div>
                            <div className="col-lg-6 mt_md--30 mt_sm--30">
                                <div className="content">
                                    <div className="inner">
                                        <h4 className="title">Mohamed Ali Bouzir</h4>
                                        <ul className="contact-address">
                                            <li><FiFile /> Web Master at Excom SB</li>
                                            <li><FiMail /> mohamedalibouzir@ieee.org</li>
                                            <li><FiPhone /> +216 54 641 991</li>
                                            <li><FiMapPin /> Sousse, Tunisia</li>
                                        </ul>
                                    </div>
                                    <div className="col-lg-6 col-md-5 mt_sm--20">
                                        <div className="copyright-center text-center">
                                            <ul className="social-icon social-default color-lessdark justify-content-center" >
                                                {socialmedia.map((data, index)=>
                                                    <li key={index}><Link target="_blank" to={{pathname: data.link}}>{data.icon}</Link></li>)}
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default AboutFive;